export default __webpack_public_path__ + "static/media/DiagonalLeftCard.48fd2e94.svg";